module.exports = __webpack_public_path__ + "img/del_icon.b5d9ac52.svg";